import { render, staticRenderFns } from "./ViewTemplatesWkhtml.vue?vue&type=template&id=bd88ffec"
import script from "./ViewTemplatesWkhtml.vue?vue&type=script&lang=js"
export * from "./ViewTemplatesWkhtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports